var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_3578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 19.6875V17.8125C15.9375 16.8179 15.5424 15.8641 14.8391 15.1609C14.1359 14.4576 13.1821 14.0625 12.1875 14.0625H4.6875C3.69294 14.0625 2.73911 14.4576 2.03585 15.1609C1.33259 15.8641 0.9375 16.8179 0.9375 17.8125V19.6875",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 10.3125C10.5086 10.3125 12.1875 8.63357 12.1875 6.5625C12.1875 4.49143 10.5086 2.8125 8.4375 2.8125C6.36643 2.8125 4.6875 4.49143 4.6875 6.5625C4.6875 8.63357 6.36643 10.3125 8.4375 10.3125Z",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 19.6875V17.8125C21.5619 16.9816 21.2853 16.1744 20.7763 15.5177C20.2672 14.8611 19.5545 14.392 18.75 14.1843",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.93433C15.8066 3.14086 16.5216 3.60998 17.0322 4.26774C17.5427 4.9255 17.8199 5.73448 17.8199 6.56714C17.8199 7.3998 17.5427 8.20878 17.0322 8.86654C16.5216 9.52429 15.8066 9.99342 15 10.2",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_3578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e3b62cdc8202c0f2bd9e5728893a49c8.svg";
export { ForwardRef as ReactComponent };